<template>
  <Row :gutter="20" type="flex" class="grid-list-row" :class="getAlertClass">
    <!--class="grid-row alert-list alert-red"-->
    <!-- <Alert size="large" :closable="false">
      <svgicon class="alert-icon" name="info" width="4" height="12" />
      Vehicle late by<br>
      2 Days & 1 Hr:11 mins
    </Alert> -->
    <Alert v-if="errorMessage.length" size="large"  type="info" width="auto" trigger="click" :closable="false">
        <span v-for="error in errorMessage">{{error}}</span>
      </Alert>
    <Col
      v-for="(header,index) in headers"
      :key="index"
      :span="header.colSpan"
      :align="!header.subDetail || !values[header.subDetail.column]?'middle':''"
    >
      <span v-if="header.column === 'status' && status" class="status status-icon" v-bind:class="status.colorName">
        {{status.name}}
        <span class="badge" v-if="trackingType && trackingType.iconName">
           <svgicon :name="trackingType.iconName" width="7" height="10" />
        </span>
      </span>
      <p v-else>
        <Ellipsis
          v-if="header.truncate"
          :text="values[header.column]"
          :length="header.truncate"
        />
        <span v-else-if="values[header.column]">{{values[header.column]}}</span>
        <span v-else>-</span>
        <small v-if="header.subDetail" :class="header.subDetail.class">
          <Ellipsis
            v-if="header.subDetail.truncate"
            :text="values[header.subDetail.column]"
            :length="header.subDetail.truncate"
          />
          <span v-else>{{values[header.subDetail.column]}}</span>
        </small>
      </p>
    </Col>
    <Col :span="4" align="middle" class="text-right">
      <router-link class="link-action" :to="{ name: 'TrackDetails', query: { id: this.details.id }}">
        <svgicon name="details" width="12" height="12" :original="true" /> Details
      </router-link>
    </Col>
  </Row>
</template>

<script>
import { trackStatus, trackType } from '@/constants/trackConstants';
import { getAddress } from '@common/lib/track';
import {
  formatLastKnownTime,
  formatEtaTime,
  getDateDiffInDaysMins,
  formatDisplaySingleDate,
} from '@/lib/Date';
import moment from 'moment';

export default {
  props: ['headers', 'details'],
  data() {
    return {
      trackStatus,
      trackType,
    };
  },
  computed: {
    status() {
      return this.trackStatus.find(val => val.value === this.details.status);
    },
    trackingType() {
      return this.trackType.find(val => val.value === this.details.typeOfTracking);
    },
    getAlertClass() {
      const val = this.getEtaDateDiff && this.getEtaDateDiff.diff;
      if (this.status && !this.status.excludeEta && val) {
        if (val < -2880) {
          return ' alert-list alert-red';
        } else if (val > 2880) {
          return ' alert-list alert-blue';
        } else if (val < -1440) {
          return ' alert-list alert-orange';
        }
      }
    },
    errorMessage() {
      const error = [];
      if (this.details && this.details.status === 'AUTO COMPLETED') {
        // error.push(this.details.autoCompleteReason);
        switch (this.details.autoCompleteReason) {
          case 'CONSENT NA':
            error.push('Consent N/A');
            break;
          case 'LOCATION NA':
            error.push('Location N/A');
            break;
          case 'PARTIAL LOCATION':
            error.push('Partial Location');
            break;
          case 'PARTIAL GEOFENCE':
            error.push('Partial Geofence');
            break;
          case 'AUTO COMPLETED':
            error.push('Auto complete days reached');
            break;
          default:
            break;
        }
      }
      return error;
    },
    getEtaDateDiff() {
      return this.details.actualEta && getDateDiffInDaysMins(this.details.actualEta, moment());
    },
    values() {
      const obj = {
        shipmentNumber: this.details.shipmentNumber,
        transporterName: this.details.transporterName,
        actualEta: this.details.actualEta ? formatEtaTime(this.details.actualEta) : 'Not Available',
        etaDetail: this.status && !this.status.excludeEta && this.details.actualEta ? this.getEtaDateDiff &&
          this.getEtaDateDiff.formatted : '',
        createdAt: formatDisplaySingleDate(this.details.createdAt),
      };
      if (this.details.firstPickup && this.details.firstPickup.address) {
        obj.source =
          `${this.details.firstPickup.address.id} - ${this.details.firstPickup.address.name}`;
        obj.sourceAddress = getAddress(this.details.firstPickup.address);
      }
      if (this.details.lastDrop && this.details.lastDrop.address) {
        obj.destination =
          `${this.details.lastDrop.address.id} - ${this.details.lastDrop.address.name}`;
        obj.destinationAddress = getAddress(this.details.lastDrop.address);
      }
      if (this.details.latestLocation) {
        obj.lastKnownPlace = this.details.latestLocation.city || this.details.latestLocation.address;
        obj.lastKnownTime = formatLastKnownTime(this.details.latestLocation.timeStamp);
      }
      return obj;
    },
  },
  methods: {},
};
</script>
